var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignatureCross = function SvgSignatureCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fill: "#ababab",
    clipRule: "evenodd",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 276 347.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276 1c-51 45-99 88-145 138 46 50 94 93 145 137-20 11-103-50-170-109-28 33-56 69-83 111-34-26-25-55-9-77 9-12 32-36 61-62-29-27-52-50-61-62-16-23-25-51 9-77 27 42 55 78 83 111C173 52 256-9 276 1",
    className: "signature_cross_svg__fil0"
  })));
};
export { SvgSignatureCross as ReactComponent };
export default __webpack_public_path__ + "images/signature_cross.svg";